import { selectHelplyAccountId } from 'ducks/accounts/selectors/selectHelplyAccountId'
import { selectAccountSubdomain } from 'ducks/accounts/selectors/selectAccountSubdomain'

// Whether this Groove account has the Helply Copilot addon enabled — gates the
// copilot panel (any user in an entitled account may use it).
//
// TODO(groove-backend): back this with the real addon/entitlement. Until then,
// helply_account_id alone isn't enough (the backend now sets it on accounts
// without the copilot), so also restrict to allowlisted subdomains.
const COPILOT_SUBDOMAIN_ALLOWLIST = ['groove', 'cindychan']

export const selectHasHelplyCopilotAddon = state => {
  if (!selectHelplyAccountId(state)) return false
  return COPILOT_SUBDOMAIN_ALLOWLIST.includes(selectAccountSubdomain(state))
}
